import { useDndContext } from '@dnd-kit/core';
import { SortableContext } from '@dnd-kit/sortable';

import { ParticipantDto, RcfAttributes, TournamentTeam } from '@features/shared/api/typings';
import { ParticipantRow } from '@features/tournament/ui/components/TournamentParticipantsEdit/components/ParticipantRow';
import { TeamOptionType } from '@features/tournament/ui/components/TournamentParticipantsEdit/components/SelectTeamPopover';
import { TeamRow } from '@features/tournament/ui/components/TournamentParticipantsEdit/components/TeamRow';

type TeamWithParticipantsProps = {
  num: number;
  team: TournamentTeam;
  participants: ParticipantDto[];
  teamOptions: TeamOptionType[];
  isSchoolEvent: boolean;
  isRcf: boolean;
  openRcfModalUserId: string | null;
  setOpenRcfModalUserId: (userId: string | null) => void;
  maxParticipantsInTeam: number;
  onBanTeam?: (teamId: string) => void;
  onDeleteTeam?: (teamId: string) => void;
  onRenameTeam?: (teamId: string, name: string) => void;
  onDelete?: (id: string) => void;
  onAccept?: (id: string) => void;
  onRemove?: (id: string) => void;
  onBan?: (id: string) => void;
  onPgnDownload?: (id: string) => void;
  onSelectTeam?: (userId: string, teamId: string | null) => void;
  onRcfAttributesChange?: (newValue: RcfAttributes) => void;
  onSetOrder?: (id: string, num: number) => void;
  sortDisabled?: boolean;
  showNumbers: boolean;
};
export function TeamWithParticipants({
  num,
  team,
  participants,
  teamOptions,
  isSchoolEvent,
  isRcf,
  openRcfModalUserId,
  setOpenRcfModalUserId,
  maxParticipantsInTeam,
  onBanTeam,
  onDeleteTeam,
  onRenameTeam,
  onDelete,
  onAccept,
  onRemove,
  onBan,
  onPgnDownload,
  onSelectTeam,
  onRcfAttributesChange,
  onSetOrder,
  sortDisabled,
  showNumbers,
}: TeamWithParticipantsProps) {
  const { active } = useDndContext();

  const participantIds = participants.map((p) => p.userId);

  const maxLimitReached = maxParticipantsInTeam && participants.length >= maxParticipantsInTeam;
  let teamDisabled = false;
  let participantsDisabled = false;

  // Засериваем участников заполненных команд.
  if (
    maxLimitReached &&
    active &&
    active.data.current?.type === 'participant' &&
    participantIds.indexOf(active.id as string) === -1
  ) {
    teamDisabled = true;
    participantsDisabled = true;
  }

  // Участников засериваем, когда тащим команды
  if (active && active.data.current?.type === 'team') {
    participantsDisabled = true;
  }

  return (
    <>
      <TeamRow
        num={num}
        name={team.name}
        teamId={team.teamId}
        onBan={onBanTeam}
        onDeleteTeam={onDeleteTeam}
        onRename={onRenameTeam}
        sortDisabled={sortDisabled}
        disabled={teamDisabled}
        isRcf={isRcf}
        isSchoolEvent={isSchoolEvent}
        showNumbers={showNumbers}
      />

      <SortableContext items={participants.map((p) => p.userId)}>
        {participants.map((participant) => (
          <ParticipantRow
            key={participant.userId}
            num={participant.numberInTeam!}
            participant={participant}
            teamOptions={teamOptions}
            isSchoolEvent={isSchoolEvent}
            isRcf={isRcf}
            isRcfModalOpen={openRcfModalUserId === participant.userId}
            setRcfModalOpen={setOpenRcfModalUserId}
            sortDisabled={sortDisabled}
            showNumbers={showNumbers}
            onDelete={onDelete}
            onAccept={onAccept}
            onRemove={onRemove}
            onBan={onBan}
            onPgnDownload={onPgnDownload}
            onSelectTeam={onSelectTeam}
            onRcfAttributesChange={onRcfAttributesChange}
            onSetOrder={onSetOrder}
            disabled={participantsDisabled}
          />
        ))}
      </SortableContext>
    </>
  );
}
